export default __webpack_public_path__ + "static/media/BrainBreak cards90.0cee8bec.png";